export default __webpack_public_path__ + "static/media/rolling.b31fa642.gif";